import styled, { css } from "styled-components";
import { Button as MuiButton } from "@mui/material";
import { ThemeColors } from "util/theme";

export const Button = styled(MuiButton).attrs({
  variant: "contained",
})`
  text-transform: none;
  font-size: 20px !important;
  letter-spacing: 2.5px;
  min-height: 54px;
  border-radius: 0 !important;
  box-shadow: none;
  color: white !important;

  &:hover {
    box-shadow: none;
    background-color: ${ThemeColors.BLUE} !important;
  }

  &.Mui-disabled {
    background-color: ${ThemeColors.BLUE} !important;
    color: rgba(255, 255, 255, 0.3) !important;
  }

  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: 14px !important;
    min-height: 44px;
  }
`;
